import { DebitType } from '../types/DebitType';

/**
 * Formats a DebitType value to its Swedish display unit
 * @param priceType - The DebitType value (e.g., 'monthly', 'weekly')
 * @param prefix - The prefix to add to the unit string (e.g., '/' or '-')
 * @returns The Swedish unit string (e.g., '/ månad', '/ vecka')
 */
export const formatDebitTypeUnit = (priceType: string, prefix: string = '/'): string => {
  switch (priceType) {
    case DebitType.Monthly:
      return `${prefix} månad`;
    case DebitType.Weekly:
      return `${prefix} vecka`;
    case DebitType.Ongoing:
      return `${prefix} tim`;
    case DebitType.Unit:
      return `${prefix} tillfälle`;
    default:
      return '';
  }
};
